import { render, staticRenderFns } from "./bar1.vue?vue&type=template&id=872226d8&scoped=true&"
import script from "./bar1.vue?vue&type=script&lang=js&"
export * from "./bar1.vue?vue&type=script&lang=js&"
import style0 from "./bar1.vue?vue&type=style&index=0&id=872226d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872226d8",
  null
  
)

export default component.exports